import fixedControlOptionDefinitions from './fixedControlOptionDefinitions';
import customControlOptionDefinitions from './customControlOptionDefinitions';

const controlOptionDefinitions = {
  ...customControlOptionDefinitions,
  ...fixedControlOptionDefinitions,
};

export default controlOptionDefinitions;
